import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminLogisticPartnerService } from '../../../_services/admin-logistic-partner.service';

@Component({
    selector: 'app-reject-logistic-partner-modal',
    templateUrl: './reject-logistic-partner-modal.component.html',
    styleUrls: ['./reject-logistic-partner-modal.component.css'],
    standalone: false
})
export class RejectLogisticPartnerModalComponent implements OnInit {
    partnerId: string = '';
    rejectForm: FormGroup;
    submitted = false;

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private adminLogisticPartnerService: AdminLogisticPartnerService,
        private toastr: ToastrService
    ) {
        this.rejectForm = this.fb.group({
            reason: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]]
        });
    }

    ngOnInit(): void {
        this.partnerId = this.route.snapshot.params['partnerId'];
        if (!this.partnerId) {
            this.router.navigate(['/admin', 'logistic-partners']);
        }
    }

    get f() {
        return this.rejectForm.controls;
    }

    onSubmit(): void {
        this.submitted = true;

        if (this.rejectForm.invalid) {
            return;
        }

        const reason = this.rejectForm.value.reason;

        this.adminLogisticPartnerService.rejectPartner(this.partnerId, reason).subscribe({
            next: () => {
                this.toastr.success('Logistic partner rejected successfully');
                this.router.navigate(['/admin', 'logistic-partners', this.partnerId]);
            },
            error: () => {
                this.toastr.error('Error rejecting logistic partner');
            }
        });
    }

    onCancel(): void {
        this.router.navigate(['/admin', 'logistic-partners', this.partnerId]);
    }
}
